module.exports = __webpack_public_path__ + "img/portfolio_5.2281cfe4.png";